export const Permissions = {
  ActivityTaskIsActiveEdit: "ActivityTaskIsActiveEdit",
  AlloyAdmin: "AlloyAdmin",
  BranchAdmin: "BranchAdmin",
  BranchCipOverride: "BranchCipOverride",
  BranchCipRerun: "BranchCipRerun",
  BranchDocumentExport: "BranchDocumentExport",
  BranchGetIdentificationImage: "BranchGetIdentificationImage",
  BranchRuleAdmin: "BranchRuleAdmin",
  BranchRuleReadonly: "BranchRuleReadonly",
  BranchUser: "BranchUser",
  CoreUser: "CoreUser",
  FisAdmin: "FisAdmin",
  FisUser: "FisUser",
  JxchangeAuxAdmin: "JxchangeAuxAdmin",
  JxchangeAuxUser: "JxchangeAuxUser",
  LaunchpadAdmin: "LaunchpadAdmin",
  LaunchpadCron: "LaunchpadCron",
  LaunchpadUser: "LaunchpadUser",
  PigeonAdmin: "PigeonAdmin",
  PigeonUser: "PigeonUser",
  SynergyAdmin: "SynergyAdmin",
  UiAdmin: "UiAdmin",
  UiUser: "UiUser",
  WolterskluwerAdmin: "WolterskluwerAdmin",
} as const
